import { ApiClient } from '../../core/api/ApiClient';
import { PharmacySettingsRepositoryImpl } from './implementations/PharmacySettingsRepositoryImpl';

export { PharmacySettingsRepositoryImpl };

let repository = null;

/** PharmacySettings Repository 싱글톤 접근자 */
export const getPharmacySettingsRepository = () => {
  if (!repository) {
    const baseURL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:8000/api/v1';
    repository = new PharmacySettingsRepositoryImpl(new ApiClient(baseURL));
  }
  return repository;
};
